











































import { Component, Vue } from 'vue-property-decorator'
import CalculatorResult from '@/components/calculator/CalculatorResult.vue'
import CalculatorForm from '@/components/calculator/CalculatorForm.vue'
import CalculateStore from '@/stores/CalculateStore'
import ResultDescription from '@/components/calculator/ResultDescription.vue'

@Component({
  components: {
    ResultDescription,
    CalculatorForm,
    CalculatorResult,
  },
})
export default class CalculatorPage extends Vue {
  isPending = false

  get isCalculated(): boolean {
    return CalculateStore.isCalculated
  }

  get isNotFound(): boolean {
    return CalculateStore.isNotFound
  }

  submit() {
    this.isPending = true

    CalculateStore.calculateDeliveries().finally(() => (this.isPending = false))
  }
}
